<template>
    <div class="form">
        <Form
            ref="info"
            :label-width="80"
            :model="info"
            :rules="ruleValidate"
            :viewonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="管家姓名" prop="userId">
                        <Select
                            v-model="info.userId"
                            filterable
                            @on-change="selectManage"
                        >
                            <Option
                                v-for="item in manageList"
                                :key="item.value"
                                :value="item.id"
                                :label="item.nickname"
                                >{{ item.nickname }} {{ item.phone }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机号" prop="phone">
                        <Input v-model="info.phone" placeholder disabled />
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="负责楼栋" prop="floorIds">
                        <select-tree
                            v-model="info.floorIds"
                            :list="parkList"
                            multiple
                            fullPathName
                        ></select-tree>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="店面名称" prop="shopId">
                        <Select
                            v-model="info.shopId"
                            filterable
                            @on-change="selectShop"
                        >
                            <Option
                                v-for="item in shopList"
                                :key="item.id"
                                :value="item.id"
                                :label="item.shopName"
                            ></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="店面电话" prop="tel">
                        <Input v-model="info.tel" placeholder disabled />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="店面地址" prop="addr">
                        <Input v-model="info.addr" placeholder disabled />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import mSelectAssetsPark from '@/views/common/m-select-assets-park'

import {
    shopManageView,
    shopManageAdd,
    shopManageUpdate,
    shopInfoList,
    queryFloorIds,
} from '@/api/shop'
import { userList } from '@/api/sys-user'

export default {
    name: 'MManageForm',
    mixins: [mSelectAssetsPark],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                userId: '', // 管家id
                nickname: '', // 管家姓名
                phone: '', // 管家手机号
                shopName: '', // 店面名称
                tel: '', // 店面电话
                shopId: '', //
                addr: '', // 店面地址
                floorIds: '', //负责楼栋的编号
                ver: '',
            },
            isView: this.actionType === '2' ? true : false,
            dict: {
                invoiceType: this.$dict.NULL,
            },
            shopList: [], // 店面列表
            manageList: [], // 管家列表
            parkList: [], // 房源列表
        }
    },
    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      userId: [{ required: true, message: '管家必填' }],
                      floorIds: [{ required: true, message: '负责楼栋必填' }],
                      shopId: [{ required: true, message: '店面必填' }],
                  }
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return shopManageView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        selectManage() {
            const manage = this.manageList.find(
                (v) => v.id === this.info.userId
            )
            this.info.phone = manage.phone
        },
        selectShop() {
            const shop = this.shopList.find((v) => v.id === this.info.shopId)
            this.info.tel = shop.tel
            this.info.addr = shop.addr
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.actionType === '1' || this.actionType === '3') {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                shopInfoList({ page: 1, pageSize: 9999 }),
                userList({ page: 1, pageSize: 9999 }),
                this.fetchAssetsPark(),
                queryFloorIds(this.id),
            ])
                .then((args) => {
                    let [view, shop, user, parkList, chooseFloorIdsList] = args

                    if (view) {
                        const viewData = view.data.entity
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                    }
                    chooseFloorIdsList = chooseFloorIdsList.data.list
                    this.shopList = shop.data.page.list
                    this.manageList = user.data.page.list
                    parkList.forEach((v) => {
                        const floor = chooseFloorIdsList.find((p) => p === v.id)

                        if (floor) {
                            v.selectable = false
                        }
                    })
                    this.parkList = parkList
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return shopManageUpdate({
                            id: formData.id,
                            userId: formData.userId,
                            shopId: formData.shopId,
                            floorIds: formData.floorIds,
                            ver: formData.ver,
                        })
                    } else {
                        return shopManageAdd({
                            userId: formData.userId,
                            shopId: formData.shopId,
                            floorIds: formData.floorIds,
                        })
                    }
                })
                .then((res) => {
                    if (this.invoiceId) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>

<style lang="scss" scoped></style>
